
import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Select from 'react-select';
import './home.css';
import { FaMobileAlt } from 'react-icons/fa';
import { getCampaigns } from '../../servicios/Campaigns';
import { getLeadGenerator } from '../../servicios/GetLeadGenerator';
import { getTypeLead } from '../../servicios/Tipolead';
import Url from '../../global/Url';
import { getValidacionBase } from '../../servicios/GetValidacionBase';
import { postLeadExterno } from '../../servicios/PostLeadExterno';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const logo = process.env.PUBLIC_URL + '/tigo_logo.svg';
let socket = null;
let userAssigning;
let userIdentify;
let defaultGestor;
let Lead;
const Home = () => {
  const navigate = useNavigate();
  const userLogin = JSON.parse(sessionStorage.getItem('user'));

  const textInput = useRef(null);
  const [isConnected, setIsConnected] = React.useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleAsigBase, setModalVisibleAsigBase] = useState(false);
  const [limite, setLimite] = useState(50); // cuántos registros pedir a la API (máx. 500)

  const [Alerta, setAlerta] = useState(false);
  const [StateAlerta, setStateAlerta] = useState({
    titulo: "",
    subtitulo: ""
  });

  const [AlertaValidaciones, setAlertaValidaciones] = useState(false);
  const [StateAlertaValidaciones, seStateAlertaValidaciones] = useState({
    titulo: "",
    subtitulo: ""
  });


  const [stateValidacionBase, seStateValidacionBase] = useState({
    Estado: "",
    Base: ""
  });

  const [state, setState] = useState({
    Tipolead: [],
    LabelCampaigns: '',
    LabelTipoLead: 'WS-V. VIRTUALES',
    LabelOferta: '',
    LabelOperadora: '',
    LabelGestor: '',
    Numero: '09',
    Campaign: [],
    Oferta: [],
    Operadora: [],
    Gestores: [],
    Gestores1: [],
  });

  const [stateModal, setStateModal] = useState({
    Numero: '',
    EstadoAsignado: '',
    Fecha: '',
    Asesor: '',
    Estado: '',
    Gestion: '',
    Canal: '',
    titulo: '',
    subtitulo: '',
    fecha_creacion: ''
  });

  var f = new Date();
  let fecha = (f.getDate() > 9 ? f.getDate() : '0' + f.getDate()) + "-" + ((f.getMonth() + 1) > 9 ? (f.getMonth() + 1) : '0' + (f.getMonth() + 1)) + "-" + f.getFullYear();

  const [stateDatosLead, setDatosLead] = React.useState({
    Identificacion: '',
    Nombres: '',
    Apellidos: '',
    Leads: [],
    NumLeads: 0
  });

  const fetchDataLeadAsignado = async (numero) => {
    try {
      const response = await fetch(`${Url.Api}empleadoIdW/${numero}`, {
        // method: 'GET',
        // headers: {
        //     'Content-Type': 'application/json'
        // }
      });

      const json = await response.json();
      if (json && json.length > 0) {

        fetch(`${Url.Api}datosClienteAsignadoW/${json[0].id}`
          , {
            // method: 'GET',
            // headers: {
            //   'Content-Type': 'application/json'
            // }
          }
        ) // Cambia la IP a la de tu servidor
          .then((response1) => response1.json())
          .then((json1) => {

            const leadsArray = Array.isArray(json1) ? json1 : (json1 ? [json1] : []);
            const numLeads = leadsArray.length;
            setDatosLead({
              ...stateDatosLead,
              Identificacion: json[0].identificacion,
              Nombres: json[0].nombres,
              Apellidos: json[0].apellidos,
              Leads: leadsArray,
              NumLeads: numLeads
            })
            sendMessage(json[0].identificacion,
              leadsArray,
              numLeads);
          }).catch((error) => {
            console.error(error);

          });

      } else {
        console.warn("No se encontraron datos para el número:", numero);
      }
    } catch (error) {
      console.error("Error al obtener los datos del lead:", error);
    }

  };

  const fetchDataUpdate = async (idUser, estado) => {
    try {
      const response = await fetch(Url.Api + 'actualizarUsuario/' + idUser + '/' + estado, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Network response was not ok: ${response.status} - ${errorMessage}`);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };




  useEffect(() => {

    if (userLogin === null) {
      navigate('/signin');

    } else {
      userIdentify = userLogin.identify;
      userAssigning = userLogin.userId;

      Datos();
      fetchData();


      const connectWebSocket = () => {

        if (!socket || socket.readyState === WebSocket.CLOSED) {
          // En https va por el proxy seguro de nginx (wss -> ws del CRM por LAN),
          // así no rompe la regla de contenido mixto. En http local, directo al CRM.
          const wsUrl = window.location.protocol === 'https:'
            ? `wss://${window.location.host}/ws-notif/`
            : 'ws://10.10.107.232:8082';
          socket = new WebSocket(wsUrl);

          socket.onopen = () => {

            setIsConnected(true);

            console.log('Conectado al servidor websocket');
            //socket.send(JSON.stringify({ action: 'login', userId: userLogin.userId }));

          };


          // socket.onmessage = (event) => {
          //     const data = JSON.parse(event.data);
          //     Alert.alert(`Nuevo lead reasignado: ${data.sms}`);
          // };

          socket.onclose = () => {
            setIsConnected(false);
            //navigate('/signin');
            //sessionStorage.setItem('user', null);
            console.log('Conexión cerrada');
          };

          socket.onerror = (error) => {
            console.error('Error en la conexión WebSocket:', error);
            socket.close();
          };

        }


      };


      connectWebSocket();

      return () => {
        if (socket) {
          socket.close();
          console.log('Conexión WebSocket cerrada al desmontar el componente');
        }
      };
    }





  }, []);

  const sendMessage = async (leadIdentificacion, Leads, numLeads) => {

    if (socket && isConnected) {
      const message = JSON.stringify({
        sms: 'Gestion Leads: Tienes una nueva asignacion',
        action: 'joinRoom',
        roomId: leadIdentificacion,
        leads: Leads,
        numLead: numLeads
      }); // Define el roomId que necesites

      try {
        socket.send(message);

        const leaveMessage = JSON.stringify({
          action: 'leaveRoom',
          roomId: leadIdentificacion,
          sms: ''
        });

        socket.send(leaveMessage);

      } catch (error) {
        console.error('Error al enviar el mensaje:', error);
      }

    }
  };




  const TipoLeads = () => {
    return (
      <>
        {state.Tipolead && state.Tipolead.length > 0 ? (
          state.Tipolead.map((x, index) => {
            return (
              <div className="form-check" key={index}>
                <label style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <input
                    type="radio"
                    name="tipoLead"
                    value={x.detail}
                    checked={state.LabelTipoLead === x.detail}
                    onChange={() => getTipoLeads(x.detail)}
                  />
                  {x.detail}
                </label>
              </div>
            );
          })
        ) : (
          <p>No hay datos disponibles</p>
        )}
      </>
    );
  };


  const getTipoLeads = (value) => {
    setState({ ...state, LabelTipoLead: value });
  };

  const fetchGestorLead = async () => {
    let data = [];
    try {
      const res = await fetch(Url.Api + 'obtenerLeadGestor');
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const json = await res.json();
      // Si viene un array, lo usamos; si no, dejamos vacío
      data = Array.isArray(json) ? json : [];
    } catch (error) {
      console.error('Error al obtener LeadGestor:', error);
      data = [];
    }
    // Y devolvemos el array para quien llame
    return data;
  };


  const Datos = async () => {
    try {

      const TipoLead = await getTypeLead();

      setState({
        ...state,
        Tipolead: TipoLead // Asume que data es un array
      })

      const ComboCampaign = await getCampaigns('Forma');
      const ComboOferta = await getCampaigns('Oferta');
      const ComboOperadora = await getCampaigns('Operadora');

      const ComboGestores = await fetchGestorLead();

      const DataCampaign = ComboCampaign.map(function (x) {
        return { key: x.key, label: x.campaign, value: x.campaign };
      });
      const DataOferta = ComboOferta.map(function (x) {
        return { key: x.key, label: x.campaign, value: x.campaign };
      });
      const DataOperadora = ComboOperadora.map(function (x) {
        return { key: x.key, label: x.campaign, value: x.campaign };
      });

      const DataGestores = ComboGestores
        .filter(x => x.id_solicitudes === userIdentify)
        .map(x => ({
          key: x.id_solicitudes,
          label: x.agent,
          value: x.id_solicitudes
        }));

      const DataGestores1 = ComboGestores.map(function (x) {
        return { key: x.id_solicitudes, label: x.agent, value: x.id_solicitudes };
      });



      setState({
        ...state,
        Tipolead: TipoLead,
        Campaign: DataCampaign,
        Oferta: DataOferta,
        Operadora: DataOperadora,
        Gestores: DataGestores,
        Gestores1: DataGestores1


      });

    }
    catch (e) {
    }
  }


  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${Url.Api}asignacionesWeb?limit=${limite}`, {
        // method: 'GET',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
      });

      if (!response.ok) {
        const errorMessage = await response.text(); // Captura el cuerpo del error
        throw new Error(`Network response was not ok: ${response.status} - ${errorMessage}`);
      }

      const json = await response.json();
      setData(json);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Recarga la tabla cuando cambia el límite (omite la carga inicial, ya cubierta al montar)
  const firstLimiteRender = useRef(true);
  useEffect(() => {
    if (firstLimiteRender.current) {
      firstLimiteRender.current = false;
      return;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limite]);

  const [dataAsignacion, setDataAsigancion] = useState([]);

  const dataAsignaciones = async (phone) => {
    try {
      const response = await fetch(Url.Api + 'infoAsignaciones/' + phone, {
        // method: 'GET',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
      });

      if (!response.ok) {
        const errorMessage = await response.text(); // Captura el cuerpo del error
        throw new Error(`Network response was not ok: ${response.status} - ${errorMessage}`);
      }

      const json = await response.json();

      setDataAsigancion(json[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const onTextChanged = (e) => {
    const value = e.target.value;
    const reg = /^09([0-9])*$/;
    if (reg.test(value)) {
      setState({
        ...state,
        Numero: value,
        ValidarNumero: true,
      });
    } else {
      setState({
        ...state,
        ValidarNumero: false,
      });
    }
  }

  const validarcampaña = () => {
    if (state.LabelCampaigns.length === 0) {
      seStateAlertaValidaciones({
        ...StateAlertaValidaciones,
        titulo: 'Información',
        subtitulo: 'Ingrese la campaña'
      });
      setAlertaValidaciones(true);
      return false
    }
    return true
  }

  const validarTipoAsignacion = () => {
    if (!tipoAsignacion) {
      seStateAlertaValidaciones({
        ...StateAlertaValidaciones,
        titulo: 'Información',
        subtitulo: 'Seleccione el tipo de asignación',
      });
      setAlertaValidaciones(true);
      return false;
    }

    if (tipoAsignacion === 'manual' && (!state.LabelGestor || state.LabelGestor === '')) {
      seStateAlertaValidaciones({
        ...StateAlertaValidaciones,
        titulo: 'Información',
        subtitulo: 'Seleccione un gestor para la asignación manual',
      });
      setAlertaValidaciones(true);
      return false;
    }

    return true;
  };

  const validarOferta = () => {
    if (state.LabelOferta.length === 0) {
      seStateAlertaValidaciones({
        ...StateAlertaValidaciones,
        titulo: 'Información',
        subtitulo: 'Ingrese la oferta'
      });
      setAlertaValidaciones(true);
      return false
    }
    return true
  }

  const validarOperadora = () => {
    if (state.LabelOperadora.length === 0) {
      seStateAlertaValidaciones({
        ...StateAlertaValidaciones,
        titulo: 'Información',
        subtitulo: 'Ingrese la operadora'
      });
      setAlertaValidaciones(true);
      return false
    }
    return true
  }

  const validartipo = () => {
    if (state.LabelTipoLead.length === 0) {
      seStateAlertaValidaciones({
        ...StateAlertaValidaciones,
        titulo: 'Información',
        subtitulo: 'Ingrese el tipo'
      });
      setAlertaValidaciones(true);
      return false
    }
    return true
  }

  const validarnumero = () => {

    const reg = /^09([0-9])*$/;
    if (state.Numero.length === 10) {
      if (reg.test(state.Numero)) {
        return true
      }
      seStateAlertaValidaciones({
        ...StateAlertaValidaciones,
        titulo: 'Información',
        subtitulo: 'Número incorrecto'
      });
      setAlertaValidaciones(true);
      return false
    }
    seStateAlertaValidaciones({
      ...StateAlertaValidaciones,
      titulo: 'Información',
      subtitulo: 'Número incorrecto'
    });
    setAlertaValidaciones(true);
    return false
  }

  const ValidarBase = async () => {
    if (validarcampaña() && validarOferta() && validarOperadora() && validartipo() && validarTipoAsignacion() && validarnumero()) {
      const Validacion = await getValidacionBase(state.Numero);
      console.log(Validacion);

      if (Validacion.length > 0) {
        // console.log(Validacion);
        let Data = Validacion[0];
        seStateValidacionBase({
          ...stateValidacionBase,
          Estado: 'AC',
          Base: Data.database_name,
        });
        // AsignarLeads();
      } else {
        seStateValidacionBase({
          ...stateValidacionBase,
          Estado: 'DC',
          Base: 'VACIO',
        });
        // setModalVisibleAsigBase(true);
      }

      setModalVisibleAsigBase(true);
    }
  }


  const AsignarLeads = async () => {

    if (validarcampaña() && validarOferta() && validarOperadora() && validartipo() && validarnumero()) {
      const Generador = await getLeadGenerator(state.LabelCampaigns, state.LabelOferta, state.LabelOperadora, 'LEADS');
      console.log(Generador);
      if (!Generador || Generador.length === 0) {
        toast.warn("El Lead que intenta ingresar no está autorizado. Por favor comuníquese con el departamento de sistemas.")
      } else {

        if (userIdentify != null && userIdentify !== '') {
          Lead = {
            typeLead: state.LabelTipoLead,
            clientNumber: state.Numero,
            campaign: Generador[0].nombre,
            userAsig: userAssigning,
            gestorId: userIdentify
          };

        } else {
          Lead = {
            typeLead: state.LabelTipoLead,
            clientNumber: state.Numero,
            campaign: Generador[0].nombre,
            userAsig: userAssigning,
            gestorId: state.LabelGestor
          };
        }

        try {
          const response = await fetch(Url.Crm + 'reasignar', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Lead)
          });



          const responseJson = await response.json();
          console.log(responseJson.message.state_assigned);
          if (responseJson.header === "Block") {
            if (responseJson.message.state_assigned === "Solicitud Ingresada") {
              setStateModal({
                ...stateModal,
                Numero: responseJson.message.number_assigned,
                EstadoAsignado: responseJson.message.assignment_status,
                Fecha: responseJson.message.created_at,
                Asesor: responseJson.message.asesor,
                Estado: responseJson.message.state_assigned,
                Gestion: responseJson.message.comesFrom,
                Canal: responseJson.message.channelLead,
                fecha_creacion: responseJson.message.Fecha_Creacion.split(" "),
                titulo: 'OJO °-° ',
                subtitulo: 'El lead fue asignado el día de hoy'
              });
              setModalVisible(true);
            } else {
              if (responseJson.message.state_assigned === "Solicitud Incompleta") {
                setMostrarAsignacion(true); // mostrar selects
                setTipoAsignacion('manual'); // preseleccionar manual
                setState({ ...state, LabelGestor: '' });
                setValorSeleccionado(null);

                setStateModal({
                  ...stateModal,
                  Numero: responseJson.message.number_assigned,
                  EstadoAsignado: responseJson.message.assignment_status,
                  Fecha: responseJson.message.created_at,
                  Asesor: responseJson.message.asesor,
                  Estado: responseJson.message.state_assigned,
                  Gestion: responseJson.message.comesFrom,
                  Canal: responseJson.message.channelLead,
                  fecha_creacion: responseJson.message.Fecha_Creacion.split(" "),
                  titulo: 'OJO °-° ',
                  subtitulo: 'El lead fue asignado el día de hoy'
                });
                setModalVisible(true);
              } else {
                setStateModal({
                  ...stateModal,
                  Numero: responseJson.message.number_assigned,
                  EstadoAsignado: responseJson.message.assignment_status,
                  Fecha: responseJson.message.created_at,
                  Asesor: responseJson.message.asesor,
                  Estado: responseJson.message.state_assigned,
                  Gestion: responseJson.message.comesFrom,
                  Canal: responseJson.message.channelLead,
                  fecha_creacion: responseJson.message.Fecha_Creacion.split(" "),
                  titulo: 'OJO °-° ',
                  subtitulo: 'El lead fue asignado el día de hoy'
                });
                setModalVisible(true);
              }
            }

          } else {
            setStateAlerta({
              ...StateAlerta,
              titulo: responseJson.message,
              subtitulo: responseJson.body
            });
            setAlerta(true);
            setState({
              ...state,
              Numero: '09',
            });
            textInput.current.focus() // Vuelve a enfocar el campo TextInput

            // Llamada a la función async fetchDataLeadAsignado con await
            await fetchDataLeadAsignado(Lead.clientNumber);
          }

          fetchData();
          setModalVisibleAsigBase(false);
        } catch (error) {
          console.error("Error al asignar el lead:", error);
        }


      }
    }


  }



  const GuardarAsignacion = async () => {
    const Generador = await getLeadGenerator(state.LabelCampaigns, state.LabelOferta, state.LabelOperadora, 'LEADS');

    if (!Generador || Generador.length === 0) {
      toast.warn("El Lead que intenta ingresar no está autorizado. Por favor comuníquese con el departamento de sistemas.")
    } else {
      if (userIdentify != null && userIdentify !== '') {
        Lead = {
          typeLead: state.LabelTipoLead,
          clientNumber: state.Numero,
          campaign: Generador[0].nombre,
          userAsig: userAssigning,
          gestorId: userIdentify
        };

      } else {
        Lead = {
          typeLead: state.LabelTipoLead,
          clientNumber: state.Numero,
          campaign: Generador[0].nombre,
          userAsig: userAssigning,
          gestorId: state.LabelGestor
        };

      }


      try {
        const response = await fetch(Url.Crm + 'asignar', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(Lead)
        });

        const responseJson = await response.json();

        // Llamada a la función async fetchDataLeadAsignado para actualizar los datos del lead
        await fetchDataLeadAsignado(Lead.clientNumber);

        // Actualizar el estado de la alerta
        setStateAlerta({
          ...StateAlerta,
          titulo: responseJson.message,
          subtitulo: StateAlerta.subtitulo
        });
        setAlerta(true);

        // Reiniciar el estado con un número predeterminado
        setState({
          ...state,
          Numero: '09'
        });

        // Cerrar el modal
        setModalVisible(false);

        // Actualizar otros datos y enfocar el campo de entrada
        fetchData();
        textInput.current.focus()
      } catch (error) {
        console.error("Error al guardar la asignación:", error);
      }
    }
  };

  const [ValicacionAssig, seValicacionAssig] = useState(false);

  // --- Captura de leads de la plataforma externa de Movistar ---
  // Estos números nunca vienen en las cargas masivas de bases, así que
  // getValidacionBase siempre los da por no encontrados. En vez de solo advertir,
  // se capturan los datos del cliente, se registran y se asigna en un solo paso.
  const [modalCapturaLead, setModalCapturaLead] = useState(false);
  const [guardandoLead, setGuardandoLead] = useState(false);
  const [stateCaptura, setStateCaptura] = useState({
    client_identification: '',
    client_name: '',
    client_city: '',
    client_tariff: '',
    cola: ''
  });

  const limpiarCaptura = () => {
    setStateCaptura({
      client_identification: '',
      client_name: '',
      client_city: '',
      client_tariff: '',
      cola: ''
    });
  };

  const RegistrarYAsignar = async () => {
    if (stateCaptura.client_name.trim().length === 0) {
      toast.warn('Ingrese el nombre del cliente');
      return;
    }
    if (stateCaptura.client_identification.length > 0 && stateCaptura.client_identification.length !== 10) {
      toast.warn('La cédula debe tener 10 dígitos');
      return;
    }

    setGuardandoLead(true);
    const respuesta = await postLeadExterno({
      phone: state.Numero,
      client_identification: stateCaptura.client_identification,
      client_name: stateCaptura.client_name,
      client_city: stateCaptura.client_city,
      client_tariff: stateCaptura.client_tariff,
      cola: stateCaptura.cola,
      userAsig: userAssigning
    });
    setGuardandoLead(false);

    if (respuesta.header === 'OK' || respuesta.header === 'DUPLICADO') {
      if (respuesta.header === 'DUPLICADO') {
        toast.info('El número ya estaba registrado en la base de leads');
      } else {
        toast.success('Lead registrado en la base');
      }
      setModalCapturaLead(false);
      limpiarCaptura();
      AsignarLeads();
    } else {
      toast.error(respuesta.message || 'No se pudo registrar el lead');
    }
  };

  useEffect(() => {

    if (AlertaValidaciones) {
      const timer = setTimeout(() => {
        setAlertaValidaciones(false);
      }, 2500);


      return () => clearTimeout(timer);
    }

    if (Alerta) {
      const timer = setTimeout(() => {
        setAlerta(false);
      }, 2500);

      return () => clearTimeout(timer);
    }
  }, [AlertaValidaciones, Alerta]);


  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleRowClick = (item, phone) => {
    setSelectedItem(item);
    dataAsignaciones(phone);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  // Copia el número al portapapeles sin abrir el modal.
  const copiarNumero = async (numero) => {
    const texto = String(numero);
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(texto);
      } else {
        const ta = document.createElement('textarea');
        ta.value = texto;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      toast.success(`Número ${texto} copiado`, { autoClose: 1500 });
    } catch (e) {
      toast.error('No se pudo copiar el número');
    }
  };

  const [searchTerm, setSearchTerm] = useState('');

  const filteredData = data.filter(item =>
    item.numero.toString().includes(searchTerm)
  );


  const fetchNumeroBase = async (numero) => {
    try {
      const response = await fetch(Url.Api + 'asignacionesWebBase/' + numero, {
        // method: 'GET',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Network response was not ok: ${response.status} - ${errorMessage}`);
      }

      const json = await response.json();
      setData(json);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSearch = (e) => {
    // Búsqueda flexible: solo dígitos, coincidencia parcial (sirve con los
    // últimos 4 números, sin obligar a escribir el 09 del inicio).
    const value = e.target.value.replace(/\D/g, '');
    setSearchTerm(value);

    if (value === "") {
      fetchData();               // vacío -> recarga la lista completa
      return;
    }
    if (value.length === 10) {
      fetchNumeroBase(value);     // número completo -> búsqueda exacta en la base
      return;
    }
    // 1-9 dígitos: si veníamos de una búsqueda exacta (lista reducida a 1),
    // recargamos la lista completa para poder filtrar localmente por coincidencia.
    if (data.length <= 1) {
      fetchData();
    }
  };

  const [tipoAsignacion, setTipoAsignacion] = useState('automatica');
  const [valorSeleccionado1, setValorSeleccionado] = useState(null);
  const [mostrarAsignacion, setMostrarAsignacion] = useState(false);

  const opcionesTipoAsignacion = [
    { value: 'manual', label: 'Asignación Manual' },
    { value: 'automatica', label: 'Asignación Automática' },
  ];

  const opcionesGestores = userIdentify ? state.Gestores : state.Gestores1;

  const valorSeleccionado = opcionesGestores.find(
    x => x.value === (userIdentify || state.LabelGestor)
  ) || null;

  const [numeroAEliminar, setNumeroAEliminar] = useState(null);

  const handleDelete = async () => {
    const numero = numeroAEliminar;
    if (!numero) return;

    try {
      const response = await fetch(Url.Api + 'deleteAsignacion/' + numero, {
        method: 'DELETE',
      });

      const result = await response.json();

      if (result.status === 'success') {
        // Refresca la tabla
        fetchData();
        toast.success('Número eliminado correctamente');
      } else {
        toast.error('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Error al eliminar:', error);
      toast.error('Ocurrió un error al intentar eliminar el número.');
    } finally {
      setNumeroAEliminar(null);
    }
  };

  // Renderiza el menú de los react-select en un portal para que no lo recorte
  // el contenedor (.lead-card tiene overflow:hidden por las esquinas redondeadas).
  const selectPortalProps = {
    menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
    menuPosition: 'fixed',
    styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
    theme: (t) => ({
      ...t,
      colors: {
        ...t.colors,
        primary: '#214EB6',    // borde enfocado / opción seleccionada (Movistar)
        primary25: '#e6f4fe',  // hover de opción
        primary50: '#bfe3fb',  // clic de opción
      },
    }),
  };

  // Clase de color para la etiqueta de estado (por palabras clave: cubre todos los
  // estados actuales y los que aparezcan en el futuro). El orden importa: primero
  // los negativos para que "No Interesado" no caiga en el verde de "Interesado".
  const estadoBadge = (estado) => {
    const s = (estado || '').toLowerCase();

    // Rojo — negativos / cierre malo
    if (s.includes('no interesado') || s.includes('colg') || s.includes('rechaz') ||
        s.includes('fuera de servicio') || s.includes('equivocad') || s.includes('no existe')) {
      return 'lead-badge--danger';
    }
    // Verde — positivos / interés / avance bueno
    if ((s.includes('completa') && !s.includes('incompleta')) || s.includes('ingresad') || s.includes('interesado') ||
        s.includes('propuesta') || s.includes('adendum') || s.includes('venta') ||
        s.includes('cac') || s.includes('exitos') || s.includes('acept')) {
      return 'lead-badge--success';
    }
    // Ámbar — reintentar / pendiente de respuesta / incompleto
    if (s.includes('no contesta') || s.includes('no responde') || s.includes('buz') ||
        s.includes('ocupado') || s.includes('volver a llamar') || s.includes('incompleta') ||
        s.includes('desbloqueo') || s.includes('apagad') || s.includes('reagend')) {
      return 'lead-badge--warning';
    }
    // Azul — neutral / pendiente / en proceso
    if (s.includes('no llamado') || s.includes('llamado') || s.includes('interacc') ||
        s.includes('movistar') || s.includes('gesti') || s.includes('pendiente') ||
        s.includes('cobertura') || s.includes('nuevo') || s.includes('asignad')) {
      return 'lead-badge--info';
    }
    return 'lead-badge--default';
  };

  return (

    <div className="home-wrap">

      {/* ===== Sección 1: Selección y asignación de leads ===== */}
      <section className="lead-card mb-4">
        <div className="lead-card__body">
          <div className="row g-3">
            <div className="col-12 col-md-6 col-lg-4 lead-field">
              <label className="lead-label">Campaña</label>
              <Select
                options={state.Campaign}
                {...selectPortalProps}
                placeholder="Seleccione la campaña"
                onChange={(option) => setState({ ...state, LabelCampaigns: option ? option.value : '' })}
                isClearable
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4 lead-field">
              <label className="lead-label">Oferta</label>
              <Select
                options={state.Oferta}
                {...selectPortalProps}
                placeholder="Seleccione la oferta"
                onChange={(option) => setState({ ...state, LabelOferta: option ? option.value : '' })}
                isClearable
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4 lead-field">
              <label className="lead-label">Operadora</label>
              <Select
                options={state.Operadora}
                {...selectPortalProps}
                placeholder="Seleccione la operadora"
                onChange={(option) => setState({ ...state, LabelOperadora: option ? option.value : '' })}
                isClearable
              />
            </div>


            <div className="col-12 col-md-6 col-lg-4 lead-field">
              <label className="lead-label">Tipo de asignación</label>
              <Select
                options={opcionesTipoAsignacion}
                {...selectPortalProps}
                placeholder="Seleccione tipo de asignación"
                value={
                  tipoAsignacion
                    ? opcionesTipoAsignacion.find((op) => op.value === tipoAsignacion)
                    : null
                }
                onChange={(option) => {
                  setTipoAsignacion(option ? option.value : '');
                  if (option?.value !== 'manual') {
                    setState({ ...state, LabelGestor: '' }); // Limpiar gestor si cambia a automático
                    setValorSeleccionado(null);
                  }
                }}
                isClearable
              />
            </div>


            {/* Mostrar solo si es Asignación Manual */}
            {tipoAsignacion === 'manual' && (
              <div className="col-12 col-md-6 col-lg-4 lead-field">
                <label className="lead-label">Gestor</label>
                <Select
                  options={userIdentify ? state.Gestores : state.Gestores1}
                  {...selectPortalProps}
                  placeholder="Seleccione gestor"
                  value={valorSeleccionado}
                  onChange={(option) => {
                    setValorSeleccionado(option);
                    setState({ ...state, LabelGestor: option ? option.value : '' });
                  }}
                  isClearable
                />
              </div>
            )}

            {/* <div className="col-12 ">
                      <div className="mb-2 pe-4 form-control">
                          <label className="form-label" style={{color: 'hsl(0, 0%, 50%)'}}>Seleccione Tipo de Lead</label>
                      
                          <div className="d-flex justify-content-between">

                          <TipoLeads />
                              
                          </div>
                              
                      </div>
                  </div> */}

            <div className='col-12 col-lg-8 lead-field'>
              <label className="lead-label">Número de teléfono</label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaMobileAlt />
                </span>
                <input
                  ref={textInput}
                  type="text"
                  value={state.Numero}
                  className="form-control input"
                  onChange={onTextChanged}
                  maxLength={10}
                  placeholder="Ingrese el número"
                />
                <button onClick={ValidarBase} className="btn lead-btn-ingresar">
                  Ingresar
                </button>
              </div>
            </div>

            <div className='col-12'>

              {Alerta && (
                <div className="centeredView">
                  <div className="modalView">
                    {/* Si necesitas un botón para cerrar la alerta */}
                    {/* <div style={styles.HeaderModalAlert}>
                              <button
                                style={styles.botonCerrarAlert}
                                onClick={() => setAlerta(false)}  // Cierra la alerta al presionar el botón
                              >
                                <Icon name="close" size={18} color="#ffff" />
                              </button>
                            </div> */}

                    <div style={{ flexDirection: 'row', marginTop: 0, display: 'flex', alignItems: 'center' }}>
                      <i className="bi bi-flag-fill text-danger"></i>
                      <span style={{ marginLeft: 18, marginRight: 10, marginBottom: 10, color: '#000' }}>
                        {StateAlerta.titulo}
                      </span>
                    </div>

                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                      <br />
                      {StateAlerta.subtitulo === "Información del Lead encontrada" ? (
                        <span className='LetraAlerta2'> {StateAlerta.subtitulo}</span>
                      ) : (
                        <span className='LetraAlerta3'> {StateAlerta.subtitulo}</span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {AlertaValidaciones && (
                <div className="centeredView">
                  <div className="modalView">
                    {/* Si quieres incluir un botón para cerrar el modal, descomenta esto */}
                    {/* <div className="HeaderModalAlert">
                              <button
                                className="botonCerrarAlert"
                                onClick={() => setAlertaValidaciones(false)}
                              >
                                <Icon name="close" size={18} color="#ffff" />
                              </button>
                            </div> */}
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 0 }}>
                      <i className="bi bi-flag-fill text-danger"></i>
                      <span className="LetraAlerta"> {StateAlertaValidaciones.titulo}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <span
                        style={{
                          fontSize: '2vw',
                          fontFamily: 'Ubuntu, sans-serif',
                          marginLeft: '18px',
                          marginRight: '10px',
                          marginBottom: '10px',
                          color: 'red'
                        }}
                      >
                        {StateAlertaValidaciones.subtitulo}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {modalVisible && (
                <div className="centeredView">
                  <div className="modalView">
                    {stateModal.fecha_creacion[0] === fecha && (
                      <div style={{ display: 'flex', flexDirection: 'column', marginTop: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <i className="bi bi-exclamation-circle text-danger" style={{ fontSize: 18 }}></i>
                          <span className="LetraModal">{stateModal.titulo || 'Número ya registrado'}</span>
                        </div>
                        <span className="error-message">{stateModal.subtitulo || 'Este número ya fue ingresado hoy.'}</span>
                      </div>
                    )}

                    <div className="LetraModal">
                      <strong>Número: </strong>{stateModal.Numero}
                    </div>
                    <div className="LetraModal">
                      <strong>Estado: </strong>{stateModal.EstadoAsignado}
                    </div>
                    <div className="LetraModal">
                      <strong>Fecha: </strong>{stateModal.Fecha}
                    </div>
                    <div className="LetraModal">
                      <strong>Asesor: </strong>{stateModal.Asesor}
                    </div>
                    <div className="LetraModal">
                      <strong>Estado: </strong>{stateModal.Estado}
                    </div>
                    <div className="LetraModal">
                      <strong>Gestión: </strong>{stateModal.Gestion}
                    </div>
                    <div className="LetraModal">
                      <strong>Canal: </strong>{stateModal.Canal}
                    </div>

                    <span className="LetraModal1" style={{ color: '#17368A' }}>
                      <strong>¿Desea reasignar?</strong>
                    </span>

                    <div className="Botones">
                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          if (
                            stateModal.Estado === "Solicitud Incompleta" &&
                            !validarTipoAsignacion()
                          ) return;
                          GuardarAsignacion();
                          setState({
                            ...state,
                            Numero: '09',
                          });
                          textInput.current.focus();
                        }}
                      >
                        Sí
                      </button>
                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          setModalVisible(!modalVisible);
                          setState({
                            ...state,
                            Numero: '09',
                          });
                          setTipoAsignacion('automatica');
                          setValorSeleccionado(null);
                          textInput.current.focus();
                        }}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              )}


              {modalVisibleAsigBase && (
                <div className="centeredView">
                  <div className="modalView">
                    {/* Aquí podrías agregar un botón para cerrar el modal */}
                    {/* <div className="HeaderModal">
                              <button onClick={() => setModalVisibleAsigBase(!modalVisibleAsigBase)}>Cerrar</button>
                            </div> */}

                    {stateValidacionBase.Estado === "AC" ? (
                      <span className="LetraAlerta2">Información del Lead encontrada</span>
                    ) : (
                      <span className="LetraAlerta3">No se encontró Información del Lead</span>
                    )}
                    <br />
                    <span className="LetraModal1">
                      {stateValidacionBase.Estado === "AC"
                        ? '¿Desea Asignar este lead?'
                        : '¿Desea registrarlo y asignarlo?'}
                    </span>

                    <div className="Botones">

                      <button
                        className=" Boton buttonClose"
                        onClick={() => {
                          if (stateValidacionBase.Estado === "AC") {
                            AsignarLeads();
                            setModalVisibleAsigBase(!modalVisibleAsigBase);
                          } else {
                            limpiarCaptura();
                            setModalCapturaLead(true);
                            setModalVisibleAsigBase(!modalVisibleAsigBase);
                          }
                        }}
                      >
                        Sí
                      </button>

                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          setModalVisibleAsigBase(!modalVisibleAsigBase);
                          setState({
                            ...state,
                            Numero: '09',
                          });
                          setTipoAsignacion('automatica');
                          setValorSeleccionado(null);
                          textInput.current.focus();
                          // Si necesitas volver a enfocar un campo de texto, puedes agregar esa lógica aquí
                        }}
                      >
                        No
                      </button>

                    </div>
                  </div>
                </div>
              )}

              {ValicacionAssig && (
                <div className="centeredView">
                  <div className="modalView">
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 0 }}>
                      <i className="bi bi-exclamation-circle text-danger" style={{ fontSize: '18px', marginRight: '8px' }}></i>
                      <span className="LetraAlerta">Información</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <span style={{ fontSize: '2.5vh', marginTop: 10, marginLeft: 10, marginRight: 10, color: 'red' }}>
                        ¿Estás seguro de asignar Lead no encontrada?
                      </span>
                    </div>

                    <div className="Botones">

                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          AsignarLeads();
                          seValicacionAssig(!ValicacionAssig);
                          textInput.current.focus();
                        }}
                      >
                        Sí
                      </button>


                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          seValicacionAssig(!ValicacionAssig);
                          setState({
                            ...state,
                            Numero: '09',
                          });
                          setTipoAsignacion('automatica');
                          setValorSeleccionado(null);
                          textInput.current.focus();
                          // Si necesitas volver a enfocar un campo de texto, puedes agregar esa lógica aquí
                        }}
                      >
                        No
                      </button>

                    </div>
                  </div>
                </div>
              )}

              {modalCapturaLead && (
                <div className="centeredView">
                  <div className="modalView lead-capture">
                    <h3 className="mv-title">Registrar lead de Tigo</h3>
                    <p className="mv-text">
                      El número <strong>{state.Numero}</strong> no está en la base.
                      Copia los datos del cliente desde la plataforma de Tigo.
                    </p>

                    <div className="lead-capture__field">
                      <label className="lead-label">Nombre del cliente *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={stateCaptura.client_name}
                        onChange={(e) => setStateCaptura({ ...stateCaptura, client_name: e.target.value.toUpperCase() })}
                        maxLength={100}
                        placeholder="Apellidos y nombres"
                      />
                    </div>

                    <div className="lead-capture__field">
                      <label className="lead-label">Cédula</label>
                      <input
                        type="text"
                        className="form-control"
                        value={stateCaptura.client_identification}
                        onChange={(e) => {
                          const v = e.target.value;
                          if (v === '' || /^[0-9]+$/.test(v)) {
                            setStateCaptura({ ...stateCaptura, client_identification: v });
                          }
                        }}
                        maxLength={10}
                        placeholder="10 dígitos"
                      />
                    </div>

                    <div className="lead-capture__row">
                      <div className="lead-capture__field">
                        <label className="lead-label">Ciudad</label>
                        <input
                          type="text"
                          className="form-control"
                          value={stateCaptura.client_city}
                          onChange={(e) => setStateCaptura({ ...stateCaptura, client_city: e.target.value.toUpperCase() })}
                          maxLength={50}
                          placeholder="SIN DATOS"
                        />
                      </div>
                      <div className="lead-capture__field">
                        <label className="lead-label">Tarifa</label>
                        <input
                          type="text"
                          className="form-control"
                          value={stateCaptura.client_tariff}
                          onChange={(e) => setStateCaptura({ ...stateCaptura, client_tariff: e.target.value })}
                          maxLength={50}
                          placeholder="Ej. 25"
                        />
                      </div>
                    </div>

                    <div className="lead-capture__field">
                      <label className="lead-label">Cola / Campaña</label>
                      <input
                        type="text"
                        className="form-control"
                        value={stateCaptura.cola}
                        onChange={(e) => setStateCaptura({ ...stateCaptura, cola: e.target.value.toUpperCase() })}
                        maxLength={50}
                        placeholder="LEAD TIGO"
                      />
                    </div>

                    <div className="Botones">
                      <button
                        className="Boton buttonClose"
                        disabled={guardandoLead}
                        onClick={RegistrarYAsignar}
                      >
                        {guardandoLead ? 'Registrando...' : 'Registrar y asignar'}
                      </button>

                      <button
                        className="Boton mv-btn-secondary"
                        disabled={guardandoLead}
                        onClick={() => {
                          setModalCapturaLead(false);
                          limpiarCaptura();
                          setState({
                            ...state,
                            Numero: '09',
                          });
                          setTipoAsignacion('automatica');
                          setValorSeleccionado(null);
                          textInput.current.focus();
                        }}
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              )}


            </div>
          </div>
        </div>
      </section>

      {/* ===== Sección 2: Tabla de leads asignados (pantalla completa) ===== */}
      <section className="lead-card">
        <div className="lead-card__header lead-card__header--toolbar">
          <div className="lead-card__title-wrap">
            <i className="bi bi-table"></i>
            <h2 className="lead-card__title">Leads Dragon asignados</h2>
          </div>
          <div className="lead-card__toolbar">
            <div className="lead-search">
              <i className="bi bi-search"></i>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por número (o últimos dígitos)"
                value={searchTerm}
                maxLength={10}
                onChange={handleSearch}
              />
            </div>
            <button
              type='button'
              className="btn lead-btn-primary"
              onClick={fetchData}
            >
              <i className="bi bi-arrow-clockwise"></i>
              <span>Actualizar datos</span>
            </button>
          </div>
        </div>
        <div className="lead-card__body">
          <div className="table-responsive lead-lista-scroll">
            <table className="table lead-table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Estado</th>
                    <th>Tipo</th>
                    <th>Fecha</th>
                    <th>Hora</th>
                    <th>Asignador</th>
                    <th>Asesor</th>
                    <th className="text-end">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center lead-empty">No hay números asignados disponibles.</td>
                    </tr>
                  ) : (
                    filteredData.map((item) => (
                      <tr key={item.numero} className="align-middle">
                        <td className="fw-semibold">
                          <span className="lead-num">
                            {item.numero}
                            <button
                              type="button"
                              className="lead-copy"
                              title="Copiar número"
                              onClick={(e) => { e.stopPropagation(); copiarNumero(item.numero); }}
                            >
                              <i className="bi bi-clipboard"></i>
                            </button>
                          </span>
                        </td>
                        <td><span className={`lead-badge ${estadoBadge(item.estado)}`}>{item.estado}</span></td>
                        <td>{item.tipo || '—'}</td>
                        <td>{item.fecha}</td>
                        <td>{item.hora}</td>
                        <td>{item.name}</td>
                        <td>{item.nombres} {item.apellidos}</td>
                        <td className="text-end">
                          <div className="lead-actions">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRowClick(item, item.numero);
                              }}
                              className="lead-action lead-action--view"
                              title="Ver detalle"
                            >
                              <i className="bi bi-eye"></i>
                            </button>
                            {(item.estado === "No Llamado" || item.estado === "No Interesado") && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setNumeroAEliminar(item.numero);
                                }}
                                className="lead-action lead-action--danger"
                                title="Eliminar"
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            {filteredData.length > 0 && (
              <div className="lead-loadmore">
                <span className="lead-loadmore__count">
                  Mostrando {filteredData.length} registro(s){limite >= 500 ? ' (máximo)' : ''}
                </span>
                {limite < 500 && (
                  <button
                    className="lead-btn-secondary"
                    onClick={() => setLimite((l) => Math.min(l + 50, 500))}
                  >
                    <i className="bi bi-arrow-down-circle"></i> Mostrar más
                  </button>
                )}
              </div>
            )}
          </div>
        </section>

      {numeroAEliminar && (
        <div className="centeredView">
          <div className="modalView mv-confirm">
            <div className="mv-icon mv-icon--danger">
              <i className="bi bi-exclamation-triangle"></i>
            </div>
            <h3 className="mv-title">Eliminar número</h3>
            <p className="mv-text">
              ¿Seguro que deseas eliminar el número <strong>{numeroAEliminar}</strong>?
              <br />Esta acción no se puede deshacer.
            </p>
            <div className="Botones">
              <button className="Boton mv-btn-secondary" onClick={() => setNumeroAEliminar(null)}>
                Cancelar
              </button>
              <button className="Boton mv-btn-danger" onClick={handleDelete}>
                Eliminar
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      {/* Modal para mostrar detalles */}
      <Modal show={showModal} onHide={handleClose} dialogClassName="lead-detail-modal" centered>

        <Modal.Header className="lead-detail__header">
          <div className="lead-detail__header-title">
            <img src={logo} alt="Tigo" className="lead-detail__logo" />
            <span>Detalle de asignación</span>
          </div>
          <button type="button" className="lead-detail__close" onClick={handleClose} aria-label="Cerrar">
            &times;
          </button>
        </Modal.Header>

        <Modal.Body className="lead-detail__body">
          {dataAsignacion ? (
            <div className="lead-detail">
              <div className="lead-detail__row">
                <span className="lead-detail__label"><i className="bi bi-telephone"></i> Número</span>
                <span className="lead-detail__value">{dataAsignacion.phone}</span>
              </div>
              <div className="lead-detail__row">
                <span className="lead-detail__label"><i className="bi bi-flag"></i> Estado</span>
                <span className="lead-detail__value">{dataAsignacion.assignment_status}</span>
              </div>
              <div className="lead-detail__row">
                <span className="lead-detail__label"><i className="bi bi-calendar3"></i> Fecha</span>
                <span className="lead-detail__value">{dataAsignacion.assigment_date}</span>
              </div>
              <div className="lead-detail__row">
                <span className="lead-detail__label"><i className="bi bi-person"></i> Asesor</span>
                <span className="lead-detail__value">{dataAsignacion.nombres} {dataAsignacion.apellidos}</span>
              </div>
              <div className="lead-detail__row">
                <span className="lead-detail__label"><i className="bi bi-telephone-outbound"></i> Gestión</span>
                <span className="lead-detail__value">
                  {dataAsignacion.calling_status === "No Llamado"
                    ? "Gestión Telefónica"
                    : dataAsignacion.calling_status}
                </span>
              </div>
              <div className="lead-detail__row">
                <span className="lead-detail__label"><i className="bi bi-collection"></i> Tipo</span>
                <span className="lead-detail__value">LEADS</span>
              </div>
              <div className="lead-detail__row">
                <span className="lead-detail__label"><i className="bi bi-broadcast"></i> Canal</span>
                <span className="lead-detail__value">{dataAsignacion.type}</span>
              </div>
            </div>
          ) : (
            <p className="lead-detail__empty">No hay detalles disponibles.</p>
          )}
        </Modal.Body>

      </Modal>
    </div>



  );
};

export default Home;



{/*<div className='col-5'>
        <div className="container mt-4">
          <div className="row mb-3">
            <div className="col-12 pb-2">
              <Select
                options={state.Campaign}
                placeholder="Seleccione la campaña"
                onChange={(option) => setState({ ...state, LabelCampaigns: option ? option.value : '' })}
                isClearable
              />
            </div>
            <div className="col-12 pb-2">
              <Select
                options={state.Oferta}
                placeholder="Seleccione la oferta"
                onChange={(option) => setState({ ...state, LabelOferta: option ? option.value : '' })}
                isClearable
              />
            </div>
            <div className="col-12 pb-2">
              <Select
                options={state.Operadora}
                placeholder="Seleccione la operadora"
                onChange={(option) => setState({ ...state, LabelOperadora: option ? option.value : '' })}
                isClearable
              />
            </div>

            <div className="col-12 ">
              <div className="mb-2 pe-4 form-control">
                <label className="form-label"><strong>Seleccione Tipo de Lead</strong></label>

                <div className="row">

                  <TipoLeads />

                </div>

              </div>
            </div>

            <div className='col-12'>
              <div className="input-group mb-3">
                <span className="input-group-text">
                  <FaMobileAlt />
                </span>
                <input
                  ref={textInput}
                  type="text"
                  value={state.Numero}
                  className="form-control input"
                  onChange={onTextChanged}
                  maxLength={10}
                  placeholder="Ingrese el número"
                />
                <button onClick={ValidarBase} className=" btn" style={{ background: '#214EB6 ', color: 'white' }}>
                  Ingresar
                </button>
              </div>


            </div>

            <div className='col-12'>

              {Alerta && (
                <div className="centeredView">
                  <div className="modalView">
                     Si necesitas un botón para cerrar la alerta 
                     <div style={styles.HeaderModalAlert}>
                              <button
                                style={styles.botonCerrarAlert}
                                onClick={() => setAlerta(false)}  // Cierra la alerta al presionar el botón
                              >
                                <Icon name="close" size={18} color="#ffff" />
                              </button>
                            </div> 

                    <div style={{ flexDirection: 'row', marginTop: 0, display: 'flex', alignItems: 'center' }}>
                      <i className="bi bi-flag-fill text-danger"></i>
                      <span style={{ marginLeft: 18, marginRight: 10, marginBottom: 10, color: '#000' }}>
                        {StateAlerta.titulo}
                      </span>
                    </div>

                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                      <br />
                      {StateAlerta.subtitulo === "Información del Lead encontrada" ? (
                        <span className='LetraAlerta2'> {StateAlerta.subtitulo}</span>
                      ) : (
                        <span className='LetraAlerta3'> {StateAlerta.subtitulo}</span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {AlertaValidaciones && (
                <div className="centeredView">
                  <div className="modalView">
                    Si quieres incluir un botón para cerrar el modal, descomenta esto
                    <div className="HeaderModalAlert">
                              <button
                                className="botonCerrarAlert"
                                onClick={() => setAlertaValidaciones(false)}
                              >
                                <Icon name="close" size={18} color="#ffff" />
                              </button>
                            </div> 
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 0 }}>
                      <i className="bi bi-flag-fill text-danger"></i>
                      <span className="LetraAlerta"> {StateAlertaValidaciones.titulo}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <span
                        style={{
                          fontSize: '2vw',
                          fontFamily: 'Ubuntu, sans-serif',
                          marginLeft: '18px',
                          marginRight: '10px',
                          marginBottom: '10px',
                          color: 'red'
                        }}
                      >
                        {StateAlertaValidaciones.subtitulo}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {modalVisible && (
                <div className="centeredView">
                  <div className="modalView">
                    {stateModal.Estado === 'Solicitud Ingresada' ? (
                      <div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: 0 }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <i className="bi bi-exclamation-circle text-danger" style={{ fontSize: 18 }}></i>
                            <span className="LetraModal">Solicitud Ingresada</span>
                          </div>
                          <span className="error-message">
                            No se puede asignar el número
                          </span>
                        </div>

                        <div className="LetraModal">
                          <strong>Número: </strong>{stateModal.Numero}
                        </div>
                        <div className="LetraModal">
                          <strong>Estado: </strong>{stateModal.EstadoAsignado}
                        </div>
                        <div className="LetraModal">
                          <strong>Fecha: </strong>{stateModal.Fecha}
                        </div>
                        <div className="LetraModal">
                          <strong>Asesor: </strong>{stateModal.Asesor}
                        </div>
                        <div className="LetraModal">
                          <strong>Estado: </strong>{stateModal.Estado}
                        </div>
                        <div className="LetraModal">
                          <strong>Gestión: </strong>{stateModal.Gestion}
                        </div>
                        <div className="LetraModal">
                          <strong>Canal: </strong>{stateModal.Canal}
                        </div>

                        <div className="Botones">
                          <button
                            className="Boton buttonClose"
                            onClick={() => {
                              setModalVisible(!modalVisible);
                              setState({
                                ...state,
                                Numero: '09',
                              });
                              textInput.current.focus();
                              // Reset your state here if needed
                            }}
                          >
                            Salir
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {stateModal.fecha_creacion[0] === fecha && (
                          <div style={{ display: 'flex', flexDirection: 'column', marginTop: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <i className="bi bi-exclamation-circle text-danger" style={{ fontSize: 18 }}></i>
                              <span className="LetraModal">{stateModal.titulo}</span>
                            </div>
                            <span className="error-message">{stateModal.subtitulo}</span>
                          </div>
                        )}

                        <div className="LetraModal">
                          <strong>Número: </strong>{stateModal.Numero}
                        </div>
                        <div className="LetraModal">
                          <strong>Estado: </strong>{stateModal.EstadoAsignado}
                        </div>
                        <div className="LetraModal">
                          <strong>Fecha: </strong>{stateModal.Fecha}
                        </div>
                        <div className="LetraModal">
                          <strong>Asesor: </strong>{stateModal.Asesor}
                        </div>
                        <div className="LetraModal">
                          <strong>Estado: </strong>{stateModal.Estado}
                        </div>
                        <div className="LetraModal">
                          <strong>Gestión: </strong>{stateModal.Gestion}
                        </div>
                        <div className="LetraModal">
                          <strong>Canal: </strong>{stateModal.Canal}
                        </div>

                        <span className="LetraModal1" style={{ color: '#17368A' }}><strong>¿Desea reasignar?</strong></span>

                        <div className="Botones">
                          <button
                            className="Boton buttonClose"
                            onClick={() => {
                              GuardarAsignacion();
                              setState({
                                ...state,
                                Numero: '09',
                              });
                              textInput.current.focus();
                              // Reset your state here if needed
                            }}
                          >
                            Sí
                          </button>
                          <button
                            className="Boton buttonClose"
                            onClick={() => {
                              setModalVisible(!modalVisible);
                              setState({
                                ...state,
                                Numero: '09',
                              });
                              textInput.current.focus();
                              // Reset your state here if needed
                            }}
                          >
                            No
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {modalVisibleAsigBase && (
                <div className="centeredView">
                  <div className="modalView">
                    Aquí podrías agregar un botón para cerrar el modal
                   <div className="HeaderModal">
                              <button onClick={() => setModalVisibleAsigBase(!modalVisibleAsigBase)}>Cerrar</button>
                            </div>

                    {stateValidacionBase.Estado === "AC" ? (
                      <span className="LetraAlerta2">Información del Lead encontrada</span>
                    ) : (
                      <span className="LetraAlerta3">No se encontró Información del Lead</span>
                    )}
                    <br />
                    <span className="LetraModal1">¿Desea Asignar este lead?</span>

                    <div className="Botones">

                      <button
                        className=" Boton buttonClose"
                        onClick={() => {
                          if (stateValidacionBase.Estado === "AC") {
                            AsignarLeads();
                            setModalVisibleAsigBase(!modalVisibleAsigBase);
                          } else {
                            seValicacionAssig(true);
                            setModalVisibleAsigBase(!modalVisibleAsigBase);
                          }
                        }}
                      >
                        Sí
                      </button>

                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          setModalVisibleAsigBase(!modalVisibleAsigBase);
                          setState({
                            ...state,
                            Numero: '09',
                          });
                          textInput.current.focus();
                          // Si necesitas volver a enfocar un campo de texto, puedes agregar esa lógica aquí
                        }}
                      >
                        No
                      </button>

                    </div>
                  </div>
                </div>
              )}

              {ValicacionAssig && (
                <div className="centeredView">
                  <div className="modalView">
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 0 }}>
                      <i className="bi bi-exclamation-circle text-danger" style={{ fontSize: '18px', marginRight: '8px' }}></i>
                      <span className="LetraAlerta">Información</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <span style={{ fontSize: '2.5vh', marginTop: 10, marginLeft: 10, marginRight: 10, color: 'red' }}>
                        ¿Estás seguro de asignar Lead no encontrada?
                      </span>
                    </div>

                    <div className="Botones">

                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          seValicacionAssig(!ValicacionAssig);
                          AsignarLeads();
                          textInput.current.focus();
                        }}
                      >
                        Sí
                      </button>


                      <button
                        className="Boton buttonClose"
                        onClick={() => {
                          seValicacionAssig(!ValicacionAssig);
                          setState({
                            ...state,
                            Numero: '09',
                          });
                          textInput.current.focus();
                          // Si necesitas volver a enfocar un campo de texto, puedes agregar esa lógica aquí
                        }}
                      >
                        No
                      </button>

                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>


        </div>
      </div>*/}
